export const platformShadows = {
  "primitive/shadow-l1": "1px 1px 6px rgba(34, 43, 63, 0.06)",
  "primitive/shadow-l2": "3px 5px 10px rgba(34, 43, 63, 0.06)",
  "primitive/shadow-l3": "0px 2px 8px rgba(0, 0, 0, 0.1)",
  "token/card-hover": "12px 12px 32px rgba(34, 43, 63, 0.15)"
}

export type CustomShadowType = keyof typeof platformShadows
